module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.9cf8ece9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-light-webfont.woff
// module id = 495
// module chunks = 0